import React from "react";
import classes from "./TeamCard.module.css";
import { Facebook, Instagram, Twitter } from "@mui/icons-material";

function TeamCard({ img, name, designation, data }) {
  return (
    <div className={classes.teamCard}>
      {/* <div className={classes.profileImgDiv}>
        <img src={img} alt="profile-pic" />
      </div> */}

      <div className={classes.details}>
        <h4>{name}</h4>
        {data.map((d, i) => (
          <p style={{ marginBottom: "16px" }} key={i}>
            {d}
          </p>
        ))}
        <h6>{designation}</h6>
      </div>

      {/* <div className={classes.social}>
        <Facebook />
        <Twitter />
        <Instagram />
      </div> */}
    </div>
  );
}

export default TeamCard;
